import React from 'react';
import { useNavigate } from 'react-router-dom';

import Img1 from '../../img/products/bombas/BombasLobulo.png';
import Img2 from '../../img/products/bombas/BombasLobulo/BombaLobulo1.png';
import Img3 from '../../img/products/bombas/BombasLobulo/BombaLobulo2.png';
import Img4 from '../../img/products/bombas/BombasLobulo/BombaLobulo3.png';

const BombasLobulo = () => {
  const navigate = useNavigate();

  return (
    <div className="container my-5">
      <h2 className="mb-4 text-center">Bombas de Lóbulo</h2>

      {/* Estilos inline o puedes mover esto a tu CSS */}
      <style>{`
        .img-hover-zoom {
          transition: transform 0.3s ease;
        }

        .img-hover-zoom:hover {
          transform: scale(1.05);
        }
      `}</style>

      <div className="row align-items-start mb-5">
        {/* Columna izquierda: imágenes en cuadrícula */}
        <div className="col-md-5">
          <div className="row g-2">
            <div className="col-6">
              <img src={Img1} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 1" />
            </div>
            <div className="col-6">
              <img src={Img2} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 2" />
            </div>
            <div className="col-6">
              <img src={Img3} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 3" />
            </div>
            <div className="col-6">
              <img src={Img4} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 4" />
            </div>
          </div>
        </div>

        {/* Columna derecha: texto descriptivo */}
        <div className="col-md-7">
          <p className="lead text-justify">
            Las bombas de lóbulo, también conocidas como bombas de lóbulos rotativos,son un tipo de bomba 
            de desplazamiento positivo que utilizan lóbulos interdigitados para mover fluidos. 
          </p>
          <p className="lead text-justify">
            Estas bombas son reconocidas por su capacidad para manejar fluidos viscosos y abrasivos sin 
            dañarlos, y son ampliamente utilizadas en las industrias de alimentos y bebidas, farmacéutica, 
            química y de tratamiento de aguas.
          </p>
          <p className="lead text-justify">
            Los lóbulos interdigitados giran en direcciones opuestas dentro de una carcasa, creando 
            cavidades que mueven el fluido desde la entrada hasta la salida. Las bombas de lóbulo están 
            diseñadas para cumplir con estrictos estándares de higiene, lo que las hace ideales para 
            aplicaciones en las industrias de alimentos, bebidas y farmacéutica.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BombasLobulo;
